import { differenceInHours } from 'date-fns';

export function daysDiffRounded(from: Date | number, to: Date | number, minValue = 1): number {
  const hoursLeft = differenceInHours(from, to);
  return Math.round(Math.max(minValue, hoursLeft / 24));
}
